module.exports = __webpack_public_path__ + "ng.309e0794c99acc139a8a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ng.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ng.svg
// module chunks = styles